<template>
  <div class="page">
    <div class="weui-msg">
      <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">{{ worksite.shortName }}-{{ worksite.schoolCampus }}</h2>
        <div class="jine-container">
          <div class="jine-item" @click="chooseMoney(10)">
            <div class="item-title">10元</div>
            <div>可发250条短信</div>
          </div>
          <div class="jine-item" @click="chooseMoney(50)">
            <div class="item-title">50元</div>
            <div>可发1250条短信</div>
          </div>
        </div>
        <div class="jine-container">
          <div class="jine-item" @click="chooseMoney(100)">
            <div class="item-title">100元</div>
            <div>可发2500条短信</div>
          </div>
          <div class="jine-item" @click="chooseMoney(200)">
            <div class="item-title">200元</div>
            <div>可发5000条短信</div>
          </div>
        </div>
        <div class="jine-container">
          <div class="jine-item" @click="chooseMoney(500)">
            <div class="item-title">500元</div>
            <div>可发12500条短信</div>
          </div>
          <div class="jine-item" @click="chooseMoney(1000)">
            <div class="item-title">1000元</div>
            <div>可发25000条短信</div>
          </div>
        </div>
        <div class="weui-cells" style="margin-top: 15px;">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <input class="weui-input" type="number" v-model="money" placeholder="请输入充值金额（元）" />
            </div>
          </div>
        </div>
      </div>
      <p style="color: red; font-weight: bold;">支付成功后请留意"校圆通"的充值结果通知</p>
      <div class="weui-msg__opr-area">
        <p class="weui-btn-area">
          <a href="javascript:;" class="weui-btn weui-btn_primary" @click="deposit">确认充值</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import weui from "weui.js";
import axios from "axios";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      year: moment().format("YYYY"),
      token: "",
      money: null,
      userInfo: {},
      worksite: {}
    };
  },
  created() {
    let encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["chooseWXPay"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        this.userInfo = response.data.data;
        this.worksite = this.userInfo.worksite;
      })
      .catch(error => {
        console.log(error);
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    chooseMoney(money) {
      this.money = money;
    },
    deposit() {
      if (!this.money) {
        weui.alert("请输入充值金额（元）");
      } else {
        this.money = Math.floor(this.money);
        if (this.money <= 0) {
          weui.alert("充值金额必须>=1元");
        } else {
          axios
            .post("/api/common/deposit", {
              worksiteId: this.worksite._id,
              money: this.money
            })
            .then(response => {
              if (response.data.success) {
                this.money = null;
                let payConfig = response.data.data;
                wx.chooseWXPay(payConfig);
              } else {
                weui.alert("获取支付签名失败");
              }
            })
            .catch(error => {
              weui.alert("获取支付签名失败");
            });
        }
      }
    }
  }
};
</script>

<style scoped>
.name-container {
  display: flex;
  justify-content: center;
}

.short-name {
  height: 50px;
  width: 50px;
  line-height: 50px;
  padding: 5px;
  font-size: 40px;
  color: #999;
  border: 4px solid #999;
  border-radius: 50%;
  margin-bottom: 15px;
}

.weui-msg__title {
  padding-bottom: 15px;
  border-bottom: 1px solid #999;
}

.jine-container {
  display: flex;
}

.jine-item {
  margin-top: 10px;
  border: 1px solid #999;
  padding: 15px;
  flex: 1;
}

.item-title {
  font-size: 20px;
  margin-bottom: 5px;
}

.jine-item+.jine-item {
  margin-left: 10px;
}

.weui-cell {
  border-top: 1px solid #999;
  border-bottom: 1px solid #999;
}

.weui-msg__text-area {
  margin-bottom: 10px;
}

.weui-footer {
  margin-bottom: 20px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DepositMoney.vue